import React from 'react';
import {ExclamationTriangleIcon} from "@heroicons/react/24/outline";

const PublicArticleEmpty: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center text-center py-16 gap-3">
            <div className="w-12 h-12 text-on-surface/50">
                <ExclamationTriangleIcon/>
            </div>
            <h2 className="text-lg font-semibold">Nie znaleziono artykułu</h2>
            <p className="text-on-surface/60 max-w-[520px]">
                Artykuł, którego szukasz, mógł zostać usunięty albo jest tymczasowo niedostępny.
            </p>
        </div>
    );
};

export default PublicArticleEmpty;


